<template>
  <div class="page-content brand">
    <h1 class="page-title">{{ $locale('sideMenu.settings.brandManagement') }}</h1>

    <!-- Search Area -->
    <el-row class="search-area" :gutter="10">
      <el-col :span="20">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-input :placeholder="$locale('brand.operator')" v-model="filter.name">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="search_fn">{{ $locale("global.search") }}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4" class="ta-r">
        <el-button v-if="adminType !== 'brand'" class="egl-btn-yellow right-align-btn" @click="toDetail_fn('create')">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" class="egl-table">
      <el-table-column prop="name" :label="$locale('brand.operator')" min-width="300"></el-table-column>
      <el-table-column prop="cinemaNumber" :label="$locale('brand.cinemaNumber')" min-width="200"></el-table-column>
      <el-table-column prop="accountNumber" :label="$locale('brand.accountNumber')" min-width="200"></el-table-column>
      <el-table-column prop="brandCode" :label="$locale('brand.code')" min-width="200"></el-table-column>
      <el-table-column align="center" width="240">
        <template slot="header">{{ $locale("global.control") }}</template>
        <template slot-scope="scope">
          <div class="handle">
            <a @click="toDetail_fn('edit', scope.row.id)"> {{ $locale("global.edit") }}</a>
            <template v-if="adminType !== 'brand'">
              <el-divider direction="vertical"></el-divider>
              <a @click="delete_fn(scope.$index)">{{ $locale("global.delete") }}</a>
            </template>
            <div v-if="adminType === 'superAdmin'">
              <el-divider direction="vertical"></el-divider>
              <a @click="loginAs(scope.row.id)">{{ scope.row.name }} {{ $locale('setting.loginas')}}</a>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getBrandList, deleteBrand, loginAsBrand } from "@/helpers/service/api/brand.js";
import { getSystemSetting } from "@/helpers/service/api/common";
import countDownAlert from "@/utils/countDownAlert";
import CommPagination from "@/components/common/CommPagination";

import { setLocalStorage } from '@/assets/js/storage'

export default {
  name: "brand",
  components: {
    CommPagination,
  },
  data() {
    return {
      onSearch: {
        name: "",
        status: "active",
        page: 0,
        pageSize: 10,
      },
      filter: {
        name: "",
      },
      pageCount: 0,
      tableData: [],
    };
  },
  computed: {
    ...mapState("app", {
      adminType: state => state.adminType,
      cinemaObj: state => state.cinemaObj,
    }),
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapActions("app", [
      "setAppData",
    ]),
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1,
      };

      this.getList();
    },
    search_fn() {
      let obj = {
        ...this.onSearch,
        ...this.filter,
        page: 0,
      };

      this.onSearch = { ...obj };
      this.getList();
    },
    getList() {
      const that = this;
      let obj = { ...that.onSearch };

      getBrandList(obj).then(res => {
        if (res.success) {
          let tableData = [ ...res.data.data ];

          // that.pageCount = Math.ceil(res.data.count / obj.pageSize);
          that.pageCount = res.data.count || 0;
          that.tableData = tableData;
        } else {
          that.$alert(res.message, {
            showClose: false,
          });
        }
      });
    },
    toDetail_fn(act = "create", id = "") {
      let url = "/brand/create";

      if (act != "create") {
        url = "/brand/edit/" + id;
      }

      this.$router.push({ path: url });
    },
    delete_fn(index) {
      const that = this;
      const brandName = that.tableData[index].name;
      const brandId = that.tableData[index].id;
      const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${brandName}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      }).then(() => {
        // confirm
        deleteBrand({ id: brandId }).then(res => {
          if (res.success) {
            countDownAlert({
              content: this.$locale("global.deleteSuccessfully"),
              callback: () => {
                that.getList();
              }
            });
          }
        });
      });
    },
    loginAs(id) {
      let newCinemaArr = [];
      let oldCinemaArr = [ ...this.cinemaObj ];

      if (oldCinemaArr) {
        newCinemaArr = oldCinemaArr.filter(_obj => _obj.brandId === id) || [];
      }

      loginAsBrand({ id }).then(res => {
        if (res.success) {
          // NOTED: NO NEED TO UPDATE TOKEN AGAIN!!
          const {
            id, userName,
            moduleMap, permissionMap,
            type, admin,
            cinemas, brandId,
            // brandCode,
          } = res.data;
          setLocalStorage("adminType", type);
          // localStorage.set("loginAsAccountId", id);

          let userInfo = {
            userName,
            cinemas,
            cinemaId: "",
            brandId,
            moduleMap,
            permissionMap,
            adminType: type,
            isAdmin: admin,
            // brandCode,
            cinemaObj: newCinemaArr,
            loginAsAccountId: id,
          };

          this.setAppData({ data: userInfo });

          /** Get brand setting */
          getSystemSetting().then(setting_res => {
            const { round, brandCode } = setting_res.data;
            userInfo = {
              ...userInfo,
              round,
              brandCode,
            };

            this.setAppData({ data: userInfo });
            if (this.$router.history.current.path !== "/dashboard") {
              this.$router.push("/dashboard");
            }
          });
        }
      });
    },
  },
};
</script>
